import { ICellRendererParams } from "ag-grid-community";
import React from "react";

import {
  OrganizationSummarySubscriptionDto,
  SubscriptionStatus,
} from "@intelligems/ig-types";
import { StatusBadge } from "@src/features/admin/components/Icons/StatusBadge";

export const StatusColumn = (
  params: ICellRendererParams<OrganizationSummarySubscriptionDto>
) => {
  if (!params.data) {
    return null;
  }

  return <StatusBadge status={params.data.status as SubscriptionStatus} />;
};
